export const calculateSinavKaygisi = (answers) => {
  const SUB_DIMENSIONS = {
    'I. Başkalarının Görüşü': [3, 14, 17, 25, 32, 37, 41, 46],
    'II. Kendi Görüşünüz': [2, 9, 16, 24, 31, 38, 40],
    'III. Gelecek Endişesi': [1, 8, 15, 23, 30, 49],
    'IV. Hazırlanmakla İlgili': [6, 11, 18, 26, 33, 42],
    'V. Bedensel Tepkiler': [5, 12, 19, 27, 34, 39, 43],
    'VI. Zihinsel Tepkiler': [4, 13, 20, 21, 28, 35, 36, 48, 50],
    'VII. Genel Sınav Kaygısı': [7, 10, 22, 29, 44, 45]
  };

  let scores = {};
  let risks = [];
  
  Object.keys(SUB_DIMENSIONS).forEach(dim => {
    let score = 0;
    SUB_DIMENSIONS[dim].forEach(qId => {
      // Cevap "Doğru"(1) ise puan ver
      if (answers[qId] == 1 || answers[qId] === true || answers[qId] === "1") score++;
    });
    scores[dim] = score;
    
    // Risk Analizi: Soruların yarısından fazlasına "Doğru" dendiyse risktir.
    if (score > (SUB_DIMENSIONS[dim].length / 2)) {
      risks.push({ text: `${dim} alanında yüksek kaygı (${score} Puan)`, isCritical: true });
    }
  });

 // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Toplam skoru bul (50 soru üzerinden 100'lük risk puanı hesapla)
  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);
  const riskScore = Math.round((totalScore / 50) * 100);

  // Genel veya Alt Boyut Riskine göre masterRisk belirleme
  let masterRisk = "low";
  if (riskScore >= 60) masterRisk = "high"; // Genel toplamda çok yüksek kaygı
  else if (risks.length > 0) masterRisk = "medium"; // Toplam düşük olsa bile en az bir alt boyutta baraj aşılmış

  // Radarın kriz alarmını (isCritical) yanlışlıkla tetiklememek için alt boyut risklerini "high severity" yapıyoruz
  const formattedRisks = risks.map(r => ({ text: r.text, severity: "high" }));

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: riskScore,
    masterRisk: masterRisk,
    isCritical: false, // Sınav kaygısı yüksek bir risktir ama anlık/hayati kriz (critical) değildir
    domain: "academic", // Akademik odaklı bir test

    // 2. Mevcut Detaylı Veriler (Dashboard ve PDF için dokunmadık)
    summary: risks.length > 0 ? "YÜKSEK KAYGI TESPİT EDİLDİ" : "NORMAL KAYGI DÜZEYİ",
    analysis: risks.length > 0 
      ? `Öğrencinin özellikle ${risks[0].text.split(' ')[0]} alanlarında kaygısı yoğundur.` 
      : "Öğrencinin sınav kaygısı yönetilebilir düzeydedir.",
    chartData: Object.keys(scores).map(key => ({ 
      subject: key.split('.')[1].trim().substring(0, 12) + "..", 
      A: scores[key], 
      fullMark: SUB_DIMENSIONS[key].length 
    })),
    risks: formattedRisks,
    colorCode: risks.length > 0 ? "red" : "green"
  };
};